import React from 'react';
import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';


export const ArrowLeft24 = (props: SvgIconProps): JSX.Element => React.createElement(SvgIcon, props, <svg viewBox='0 0 24 24' xmlns='http://www.w3.org/2000/svg'><path d='m9.757 12 4.95 4.95a.997.997 0 0 1 .012 1.427 1 1 0 0 1-1.426-.013l-5.657-5.657a1 1 0 0 1 0-1.414l5.657-5.657a1 1 0 0 1 1.414 1.414L9.757 12Z' /></svg>);
